import CollegeCard from "../../ui/CollegeCard";
import Reveal from "../../ui/Reveal";

function StateGroupSection({ state, colleges, sectionIndex = 1 }) {
  return (
    <section className="space-y-8">
      <div className="flex flex-wrap items-center gap-4">
        <p className="text-5xl font-bold leading-none text-brand-navy/22">
          {String(sectionIndex).padStart(2, "0")}
        </p>
        <div className="h-px flex-1 bg-brand-line" />
        <h2 className="text-2xl font-semibold uppercase italic tracking-[0.08em] text-brand-navy">{state} Selection</h2>
        <p className="text-xs font-semibold uppercase tracking-[0.12em] text-brand-charcoal/66">
          {colleges.length} {colleges.length === 1 ? "College" : "Colleges"}
        </p>
      </div>

      <div className="space-y-5">
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
          {colleges.map((college, index) => (
            <Reveal key={college.id} delay={index * 0.03}>
              <CollegeCard college={college} minimal showCta={false} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default StateGroupSection;
